import React from "react";
import { Flex, forwardRef } from "@chakra-ui/react";
export const Column = forwardRef((props, ref) => (React.createElement(Flex, { ref: ref, ...props, direction: "column" })));
